import { Alert } from 'reactstrap';
import React from 'react';

function WarningAlert({ message }) {

  return (
    <Alert color="warning" className="custom-alert" fade={false}>
      <div className="custom-alert-content">
        <i className="fas fa-exclamation-triangle"></i>
        <span>{message}</span>
      </div>
    </Alert>
  )

}

export default WarningAlert;